<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="flex align-items-center justify-content-between">
      <h1 class="text-left col-6 font-bold text-4xl">Login to Airtel</h1>
    </div>
    <div class="w-full flex flex-column gap-4 py-4 px-3 bg-white border-round-2xl shadow-2">
      <p class="text-left text-base">Use the button below to open Airtel login in a new tab.</p>
      <p class="text-left text-base">
        <b>Username:</b>
        <span class="ml-2">{{airtelUsername}}</span> 
      </p>
      <p class="text-left text-base">
        <b>Password:</b>  
        <span class="ml-2">{{ showAirtelPassword ? airtelPassword : maskPassword(airtelPassword) }}</span>
        <i class="pi ml-2" [ngClass]="showAirtelPassword ? 'pi-eye-slash' : 'pi-eye'" (click)="showAirtelPassword = !showAirtelPassword"style="cursor: pointer;"></i>
      </p>
      <p-button label="Open Airtel Login" icon="pi pi-external-link" (onClick)="openAirtelLogin()" />
    </div>
  </div>
</div>
<br>
<br>
<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="flex align-items-center justify-content-between">
      <h1 class="text-left col-6 font-bold text-4xl">Login to Zoho</h1>
    </div>
    <div class="w-full flex flex-column gap-4 py-4 px-3 bg-white border-round-2xl shadow-2">
      <p class="text-left text-base">Use the button below to open Zoho login in a new tab.</p>
      <p class="text-left text-base">
        <b>Username:</b>
        <span class="ml-2">{{zohoUsername}}</span> 
      </p>
      <p class="text-left text-base">
        <b>Password:</b>  
        <span class="ml-2">{{ showZohoPassword ? zohoPassword : maskPassword(zohoPassword) }}</span>
        <i class="pi ml-2" [ngClass]="showZohoPassword ? 'pi-eye-slash' : 'pi-eye'" (click)="showZohoPassword = !showZohoPassword"style="cursor: pointer;"></i>
      </p>
      <p-button label="Open Zoho Login" icon="pi pi-external-link" (onClick)="openZohoLogin()" />
    </div>
  </div>
</div>
